import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PurchaseEntryHistoriesComponent } from 'src/app/popups/purchase-entry-histories/purchase-entry-histories.component';
import { LanguageManagementService } from 'src/service/language-management.service';
import { ActiveInactiveFor, BusinessEnabledOption, FocusInputType, InteractionType, KeyValues15, KeyValues20, KeyValues5, KeyValueSet, KeyValueSetInt, LastUsedKey, LastUsedSettingsType, LocalService, NumericConfig, ProductEntryType, PurchaseEntryDetailsInitialization, Status, UpadatePurchaseEntryDetailFor, Wrappers20 } from 'src/service/local.service';
import { ProfileManagementService } from 'src/service/profile-management.service';
import { PurchaseEntryService } from 'src/service/purchase-entry.service';

@Component({
  selector: 'app-purchase-entry-details',
  templateUrl: './purchase-entry-details.component.html',
  styleUrl: './purchase-entry-details.component.scss'
})
export class PurchaseEntryDetailsComponent {
  lstSectionConfigKeys: string[] = ["common", "table", "purchase_entry"];
  ctryCode: string = ''; businessId: string = ''; interactionType = 0; maxBodyHeight = 0;
  purchaseEntryId: string = ''; isShowInActive: boolean = false;
  purchaseEntryDetails: PurchaseEntryDetailsInitialization; isShowSpinnerCount = 0;
  source: Wrappers20; data: KeyValues15; searchItems: KeyValues5[] = [];
  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig;
  isUpdateInProgress = false; hasValidBatchDetails = false;
  purchaseEntryType: number = 1;

  priceOptions: KeyValueSet[] = [
    { isSelected: false, key: "1", value: "unit_price", s_value: "" },
    { isSelected: false, key: "2", value: "total_price", s_value: "" }
  ];
  selectedPriceOption: string = '1'; dropdownStyle: string = ''; dropdownWidth = 0;

  pageNameId = '_purchase_entry_detail_';
  elementIds: any = {
    qty: 'txt' + this.pageNameId + 'qty',
    price: 'txt' + this.pageNameId + 'price',
    add: 'btn' + this.pageNameId + 'add',
    product_dd: 'dd' + this.pageNameId + 'product',
    batch_number: 'txt' + this.pageNameId + 'batch_number',
    bar_code: 'txt' + this.pageNameId + 'bar_code',
    price_options_dd: 'dd' + this.pageNameId + 'price_options',
    status: 'status' + this.pageNameId + '_',
    status_div: 'status_div' + this.pageNameId + '_',
  };

  constructor(public localService: LocalService, private route: ActivatedRoute, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private purchaseEntryService: PurchaseEntryService, private profileManagementService: ProfileManagementService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.purchaseEntryId = routeParams.id;
      this.hasValidBatchDetails = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.IsEnableBatchDetails);
      //this.configurationManagementService.ensurePageActions(PageKey.PurchaseEntryDetails, this.businessId);
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.onGetLastUsedSettings();
    this.purchaseEntryService.getPurchaseEntryDetailsInitialization(this.businessId, this.purchaseEntryId).subscribe(result => {
      this.purchaseEntryDetails = result;
      if (this.purchaseEntryDetails.purchaseEntry.v14) {
        this.purchaseEntryType = parseInt(this.purchaseEntryDetails.purchaseEntry.v14);
      }
      this.source = this.purchaseEntryDetails.source;
      this.onSetText();
      this.onResetItem();
    });
  }

  isProcessing = false;
  onLoad() {
    if (!this.isProcessing) {
      this.isProcessing = true;
      this.purchaseEntryService.getPurchaseEntryDetails(this.businessId, this.purchaseEntryId, this.source && this.source.paging ? this.source.paging : undefined, !this.isShowInActive).subscribe(result => {
        this.source = result;
        this.onSetText();
        this.isProcessing = false;
      });
    }
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        const item = this.source.items.find(x => x.key == key);
        if (item) {
          const newValue = item.v2 ? parseFloat(item.v2) : 0;
          const oldValue = item.v11 ? parseFloat(item.v11) : 0;
          if (newValue != oldValue) {
            this.onUpdateItem(item.key, item.v2, UpadatePurchaseEntryDetailFor.Quantity);
          }
        }
      } break;
      case 2: {
        const item = this.source.items.find(x => x.key == key);
        if (item) {
          const newValue = item.v3 ? parseFloat(item.v3) : 0;
          const oldValue = item.v12 ? parseFloat(item.v12) : 0;
          if (newValue != oldValue) {
            this.onUpdateItem(item.key, item.v3, UpadatePurchaseEntryDetailFor.Price);
          }
        }
      } break;
      case 3: {
        this.onSaveLastUsedSettings();
      } break;
      case 4: {
        const modalRef = this.modalService.open(PurchaseEntryHistoriesComponent);
        modalRef.componentInstance.purchaseEntryId = key;
        modalRef.componentInstance.upadatePurchaseEntryDetailFors = this.purchaseEntryDetails.upadatePurchaseEntryDetailFors;
        modalRef.componentInstance.purchaseEntryStatuses = this.purchaseEntryDetails.purchaseEntryStatuses;
      } break;
      case 5: {
        const item = this.source.items.find(x => x.key == key);
        if (item) {
          this.onUpdateItem(item.key, item.v15, UpadatePurchaseEntryDetailFor.PurchaseEntryStatus);
        }
      } break;
    }
  }

  onSaveLastUsedSettings() {
    var items: LastUsedKey[] = [];
    const temp = this.localService.getLastUsedSetting(LastUsedSettingsType.PurchaseEntryPriceOption, this.businessId);
    var value: string = this.selectedPriceOption;
    if (temp != value)
      items.push({ keyType: LastUsedSettingsType.PurchaseEntryPriceOption, value: value } as LastUsedKey);

    if (items.length > 0) {
      this.profileManagementService.saveLastUsedSettings(items, this.businessId).subscribe(result => {
      });
    }
    this.localService.onFocusNextInput(this.elementIds.price, 1);
  }

  onGetLastUsedSettings() {
    const temp = this.localService.getLastUsedSetting(LastUsedSettingsType.PurchaseEntryPriceOption, this.businessId);
    if (temp) {
      this.selectedPriceOption = temp;
    }
  }

  onSavePurchaseEntryDetail() {
    this.purchaseEntryService.savePurchaseEntryDetail(this.purchaseEntryId, this.businessId, this.data, this.selectedPriceOption, this.purchaseEntryType, this.purchaseEntryDetails.isMaintainStatus).subscribe(result => {
      this.localService.showInformationByStatus(result.statusWithId.status);
      if (result.statusWithId.status == Status.Success) {
        this.onUpdateLocalItem(result.content);
        this.onResetItem();
      }
    });
  }

  onUpdateLocalItem(content: KeyValues20, isBringTop = true) {
    if (isBringTop) {
      this.source.items = this.source.items.filter(x => x.key != content.key);
      this.source.items.unshift(content);
      this.source.paging.totalCount = this.source.paging.totalCount + 1;
    } else {
      let item = this.source.items.find(x => x.key == content.key);
      if (item) {
        item.v1 = content.v1;
        item.v2 = content.v2;
        item.v3 = content.v3;
        item.v4 = content.v4;
        item.v5 = content.v5;
        item.v6 = content.v6;
        item.v7 = content.v7;
        item.v8 = content.v8;
        item.v9 = content.v9;
        item.v10 = content.v10;
        item.v11 = content.v11;
        item.v12 = content.v12;
        item.v13 = content.v13;
        item.v14 = content.v14;
        item.v15 = content.v15;
        item.v16 = content.v16;
        item.v17 = content.v17;
        item.v18 = content.v18;
        item.v19 = content.v19;
        item.v20 = content.v20;
      }
    }
    this.onSetText();
  }

  onUpdateItem(purchaseEntryDetailId: string, strValue: string, actionFor: UpadatePurchaseEntryDetailFor) {
    if (!this.isUpdateInProgress) {
      this.isUpdateInProgress = true;
      this.purchaseEntryService.updatePurchaseEntryDetail(purchaseEntryDetailId, actionFor, strValue, this.purchaseEntryType, this.purchaseEntryDetails.isMaintainStatus).subscribe(result => {
        this.localService.showInformationByStatus(result.statusWithId.status);
        if (result.statusWithId.status == Status.Success) {
          this.onUpdateLocalItem(result.content, false);
        }
        this.isUpdateInProgress = false;
      });
    }
  }

  onResetItem(isFocus = true) {
    this.searchItems = [];
    this.data = {
      v1: '', //Product id
      v2: '', //Quantity
      v3: '', //Price
      v4: '', //Barcode
      v13: this.purchaseEntryDetails.purchaseEntry.v13 //Batch Number
    } as KeyValues15;

    if (isFocus) {
      this.localService.onFocusNextInput(this.elementIds.product_dd, FocusInputType.NgxDropDown);
    }
  }

  onRemoveProduct() {
    this.onResetItem();
  }

  onFocusProducts() {
    if (this.searchItems.length == 0) {
      this.onSearch();
    }
  }

  onSearch(strSearchKey: string = '') {
    if (strSearchKey && strSearchKey.trim().length > 2) {
      this.isShowSpinnerCount++;
      this.purchaseEntryService.getSearchedProducts(this.businessId, strSearchKey, ProductEntryType.PurchaseEntryOnly).subscribe(result => {
        this.isShowSpinnerCount--;
        this.searchItems = result;
      });

      if (this.searchItems.length == 1 && this.searchItems[0].v4 == '1') {
        this.data.v1 = this.searchItems[0].key;
        this.localService.onFocusNextInput(this.elementIds.qty, FocusInputType.TextBox);
      }
    } else {
      this.searchItems = [];
    }
  }

  onQrScanned(value) {
    this.onSearch(value);
  }

  onActiveInactiveStatus(key: string) {
    this.purchaseEntryService.activeInactiveStatus(key, ActiveInactiveFor.PurchaseEntryDetail).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        let item = this.source.items.find(x => x.key == key);
        if (item) {
          item.v4 = item.v4 == '1' ? '0' : '1';
        }
      }
    });
  }

  onSetText() {
    if (this.purchaseEntryDetails.isMaintainStatus) {
      this.source.items.filter(x => x.v15 && x.v15 != '1').forEach(item => {
        if (this.purchaseEntryDetails.isMaintainStatus) {
          const purchaseEntryStatuse = this.purchaseEntryDetails.purchaseEntryStatuses.find(x => x.key == item.v15);
          if (purchaseEntryStatuse) {
            item.v15 = purchaseEntryStatuse.value;
          }
        }
      });

      this.dropdownStyle = '';
      const newStatusItem = this.source.items.find(x => x.v15 == '1');
      if (newStatusItem) {
        setTimeout(() => {
          const elementId = this.elementIds.status_div + newStatusItem.key;
          const element = document.getElementById(elementId);
          if (element) {
            this.dropdownWidth = element.clientWidth - 80;
            this.dropdownStyle = "width: " + this.dropdownWidth + "px; position:absolute;display: inline-block;";
          }
        }, 100);
      }
    }
  }
}